namespace GeniuzPOS.PosShift {
    export interface PsTaxInvoiceHdForm {
        DocType: Serenity.EnumEditor;
        DocNo: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        ShopId: Serenity.LookupEditor;
        RefDocNo: Serenity.LookupEditor;
        ConcatRefDocNo1: Serenity.StringEditor;
        RefDocDate: Serenity.DateEditor;
        MbId: Serenity.LookupEditor;
        TaxInvNameId: Serenity.LookupEditor;
        CusTaxTypeFg: Serenity.RadioButtonEditor;
        TaxInvName: Serenity.StringEditor;
        TaxId: Serenity.StringEditor;
        TelNo: Serenity.StringEditor;
        TaxEmail: Serenity.EmailAddressEditor;
        SalesVatType: Serenity.StringEditor;
        TaxBranchName: Serenity.StringEditor;
        TaxBranchNo: Serenity.StringEditor;
        TaxInvAddressLine1: Serenity.StringEditor;
        TaxInvAddressLine2: Serenity.StringEditor;
        TaxInvAddressLine3: Serenity.StringEditor;
        TaxPostalCode: Serenity.StringEditor;
        TaxCountryCode: Serenity.LookupEditor;
        DtList: PoPurInvoiceDtEditor;
        Remark: Serenity.StringEditor;
        GrossAmt: Serenity.DecimalEditor;
        DiscountAmt: Serenity.DecimalEditor;
        ChargeAmt: Serenity.DecimalEditor;
        SumDisChargeAmt: Serenity.DecimalEditor;
        NetAmt: Serenity.DecimalEditor;
        NetSalesNonVat: Serenity.DecimalEditor;
        NetSalesExVat: Serenity.DecimalEditor;
        NetSalesNormal: Serenity.DecimalEditor;
        VatAmt: Serenity.DecimalEditor;
        TaxInvoiceAmt: Serenity.DecimalEditor;
        RefTaxInvoiceAmt: Serenity.DecimalEditor;
        NewTaxInvoiceAmt: Serenity.DecimalEditor;
        TaxInvoiceAmtDiff: Serenity.DecimalEditor;
        NoOfPrint: Serenity.IntegerEditor;
        PostFg: Serenity.EnumEditor;
        CancelFg: Serenity.EnumEditor;
    }

    export class PsTaxInvoiceHdForm extends Serenity.PrefixedContext {
        static formKey = 'PosShift.PsTaxInvoiceHd';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsTaxInvoiceHdForm.init)  {
                PsTaxInvoiceHdForm.init = true;

                var s = Serenity;
                var w0 = s.EnumEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.LookupEditor;
                var w4 = s.RadioButtonEditor;
                var w5 = s.EmailAddressEditor;
                var w6 = PoPurInvoiceDtEditor;
                var w7 = s.DecimalEditor;
                var w8 = s.IntegerEditor;

                Q.initFormType(PsTaxInvoiceHdForm, [
                    'DocType', w0,
                    'DocNo', w1,
                    'DocDate', w2,
                    'ShopId', w3,
                    'RefDocNo', w3,
                    'ConcatRefDocNo1', w1,
                    'RefDocDate', w2,
                    'MbId', w3,
                    'TaxInvNameId', w3,
                    'CusTaxTypeFg', w4,
                    'TaxInvName', w1,
                    'TaxId', w1,
                    'TelNo', w1,
                    'TaxEmail', w5,
                    'SalesVatType', w1,
                    'TaxBranchName', w1,
                    'TaxBranchNo', w1,
                    'TaxInvAddressLine1', w1,
                    'TaxInvAddressLine2', w1,
                    'TaxInvAddressLine3', w1,
                    'TaxPostalCode', w1,
                    'TaxCountryCode', w3,
                    'DtList', w6,
                    'Remark', w1,
                    'GrossAmt', w7,
                    'DiscountAmt', w7,
                    'ChargeAmt', w7,
                    'SumDisChargeAmt', w7,
                    'NetAmt', w7,
                    'NetSalesNonVat', w7,
                    'NetSalesExVat', w7,
                    'NetSalesNormal', w7,
                    'VatAmt', w7,
                    'TaxInvoiceAmt', w7,
                    'RefTaxInvoiceAmt', w7,
                    'NewTaxInvoiceAmt', w7,
                    'TaxInvoiceAmtDiff', w7,
                    'NoOfPrint', w8,
                    'PostFg', w0,
                    'CancelFg', w0
                ]);
            }
        }
    }
}
